export type CcDigitRollSegment =
  | { kind: "digit"; value: number; digitIndex: number }
  | { kind: "text"; value: string };

/** Split a display string into animatable digits and literal separators (spaces, +, %, etc.). */
export function parseCcDigitRollText(text: string): CcDigitRollSegment[] {
  const segments: CcDigitRollSegment[] = [];
  let digitIndex = 0;

  for (const char of text) {
    if (char >= "0" && char <= "9") {
      segments.push({
        kind: "digit",
        value: Number(char),
        digitIndex,
      });
      digitIndex += 1;
    } else {
      segments.push({ kind: "text", value: char });
    }
  }

  return segments;
}

export function countCcDigitRollDigits(text: string): number {
  return parseCcDigitRollText(text).filter((part) => part.kind === "digit").length;
}
